import React from 'react';
import classnames from 'classnames';
import Text from '../Text/Text';

import './Toast.scss';

export interface ToastProps {
    /**
     * Toast title
     */
    title?: string;
    /**
     * Toast message
     */
    message?: string;
    /**
     * Class name styles
     */
    className?: string;
}

const Toast: React.FC<ToastProps> = ({ title, message, className }) => {
    const classNames = classnames(['toast', className]);

    return (
        <div className={classNames}>
            {title && (
                <Text weight="semi" typo="small" color="white" className="toast__title mb-0">
                    {title}
                </Text>
            )}
            {message && (
                <Text color="white" typo="small" className="toast__message mb-0">
                    {message}
                </Text>
            )}
        </div>
    );
};

export default Toast;
